'use client'

import { Container, Grid, styled } from '@mui/material'

import { BAR_PROPS } from '@/config/BarProps'
import { useMedia } from '@/hooks/useMedia'

import type { FC, PropsWithChildren } from 'react'

const MainBarWrapper = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  paddingBlock: 0,
  [`@media (min-width: ${theme.breakpoints.values.md}px)`]: {
    paddingBlock: theme.spacing(2),
    borderBottomWidth: 2,
    borderBottomStyle: 'solid',
    borderBottomColor: theme.palette.grey[200],
  },
}))

const MainBarWrapperDark = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.background.component,
  paddingBlock: theme.spacing(2),
  color: theme.palette.text.light,
}))

export const MainBar: FC<PropsWithChildren & { isDark?: boolean }> = ({ children, isDark = false }) => {
  const { isMobile } = useMedia()
  const WrapperComponent = isDark ? MainBarWrapperDark : MainBarWrapper

  return (
    <WrapperComponent>
      <Container disableGutters={isMobile}>
        <Grid container {...(isMobile ? {} : BAR_PROPS)}>
          {children}
        </Grid>
      </Container>
    </WrapperComponent>
  )
}
